// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time-checking-component[data-v-04851d3e]{position:relative;width:90%;margin:0 auto}@media (min-width:768px){.time-checking-component[data-v-04851d3e]{width:66%}}@media (min-width:800px){.time-checking-component[data-v-04851d3e]{width:64%}}.full[data-v-04851d3e] .field-label{font-size:12px!important;font-weight:700;color:#999;margin-bottom:4px}", ""]);
// Exports
module.exports = exports;
